export const carrotDownIcon = `
<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.740234 0.870117L11.2589 0.870117L6.7892 5.33753L6.7929 5.34053L6.00342 6.12943L0.740234 0.870117Z" fill="#191919"/>
</svg>
`;
